export default __webpack_public_path__ + "static/media/card3.1f4fd5d3.png";